import axios from "axios";
import { REST_API } from "./constants";
import { getAccessToken } from "../components/lib/auth/getAccessToken.ts";
import { jwtDecode } from "jwt-decode";
import { msalInstance } from "../components/lib/auth/msalInstance.ts";
import { useIsAuthenticated } from "@azure/msal-react";

/** App role value that grants every admin feature. */
export const COACH_ROLE = "Coaches";

/**
 * The authentication service which manages
 * authentication state of the current user
 *
 * @author Manuel
 */
class AuthService {
  /* login(username, password) {
        return axios
            .post(`${REST_API}/api/unsecure/auth/login`, {
                username,
                password
            })
            .then(response => {

                if (response.data.jwt) {
                    localStorage.setItem("user", JSON.stringify(response.data));
                    localStorage.setItem("userName", JSON.stringify(username));
                }

                return response.data;
            });
    } */

  logout() {
    msalInstance.logoutRedirect({});
  }

  hasLocalToken() {
    return useIsAuthenticated();
  }

  getLocalUser() {
    const account =
      msalInstance.getActiveAccount() ?? msalInstance.getAllAccounts()[0];
    if (!account) return null;

    const claims: any = account.idTokenClaims || {};

    const email: string =
      claims.email ||
      claims.preferred_username ||
      claims.upn ||
      account.username;

    const rawName: string | undefined = claims.name || username;

    const name =
      rawName && rawName.includes("@")
        ? rawName.split("@")[0].replace(".", " ")
        : rawName || "Unbekannt";

    const id: string =
      claims.oid || account.localAccountId || account.homeAccountId;
    const lastname = name.split(" ")[0];
    const firstname = name.split(" ")[1];

    return { id, lastname, firstname, username: email, email };
  }

  async hasAuthority(authorityToCheck: string): Promise<boolean> {
    try {
      const auth_token = await getAccessToken();
      const decoded_auth_token = jwtDecode<JWTPayload>(auth_token);

      console.log("Token roles:", decoded_auth_token.roles);
      console.log("Gesuchte Rolle:", authorityToCheck);

      return (decoded_auth_token.roles ?? []).includes(authorityToCheck);
    } catch (error) {
      console.warn("Could not read roles from access token", error);
      return false;
    }
  }

  async isCoach(): Promise<boolean> {
    return this.hasAuthority(COACH_ROLE);
  }

  hasAdminDashboardAccess(callback) {
    if (!this.hasLocalToken()) {
      callback(false);
      return;
    }

    this.isCoach().then(callback);
  }

  getCurrentUser() {
    return JSON.parse(localStorage.getItem("user"));
  }

  getCurrentUsername() {
    return JSON.parse(localStorage.getItem("userName"));
  }
}

const authService = new AuthService();
export default authService;

interface JWTPayload {
  roles?: string[];
}
